import { render, staticRenderFns } from "./ModeratorsView.vue?vue&type=template&id=1060a8dc"
import script from "./ModeratorsView.vue?vue&type=script&lang=js"
export * from "./ModeratorsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports